module.exports = __webpack_public_path__ + "eeecfdd846b65ec07535c19ba63c77af.pdf";